import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { DropdownToggle } from './DropdownToggle';
import { DropdownMenu } from './DropdownMenu';
import { Dropdown } from '.';
export const DropdownButton = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const { title, children, rootCloseEvent, bsStyle, bsSize, menuRole, renderMenuOnMount, disabled, id, usePopper, flip = true, ...rest } = props;
    return /*#__PURE__*/ _jsxs(Dropdown, {
        ref: ref,
        ...rest,
        children: [
            /*#__PURE__*/ _jsx(DropdownToggle, {
                id: id,
                bsSize: bsSize,
                bsStyle: bsStyle,
                disabled: disabled,
                children: title
            }),
            /*#__PURE__*/ _jsx(DropdownMenu, {
                role: menuRole,
                renderOnMount: renderMenuOnMount,
                rootCloseEvent: rootCloseEvent,
                usePopper: usePopper,
                flip: flip,
                children: children
            })
        ]
    });
});
DropdownButton.displayName = 'DropdownButton';
